import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=009f98e4&scoped=true&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"
import style0 from "./credit.vue?vue&type=style&index=0&id=009f98e4&prod&lang=scss&scoped=true&"
import style1 from "./credit.vue?vue&type=style&index=1&id=009f98e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f98e4",
  null
  
)

export default component.exports